import { combineReducers } from "redux";

import { loaderReducer } from "./loaderReducer/loaderReducer";
import { authReducer } from "./authReducer/authReducer";
import { userReducer } from "./userReducer/userReducer";
import { themeReducer } from "./themeReducer/themeReducer";
import { metaReducer } from "./metaReducer/metaReducer";
import { permissionsReducer } from "./permissionsReducer/permissionsReducer";
import { socketReducer } from "./socketReducer/socketReducer";

export const reducers = combineReducers({
  auth: authReducer,
  user: userReducer,
  loader: loaderReducer,
  meta: metaReducer,
  theme: themeReducer,
  permissions: permissionsReducer,
  socket: socketReducer,
});
